export default class Gift {
    constructor(receiverId, message, booksIds) {
        this.receiverId = receiverId
        this.message = message
        this.booksIds = booksIds
    }
}